import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import { createClassNameString } from "@/utils/createClassNameString";
import { LocalVideo } from "@/portals/(shared)/(video-call)/components/(steps)/LocalVideo";
import { RemoteVideo } from "@/portals/(shared)/(video-call)/components/(steps)/RemoteVideo";

import { CarePlanWidget } from "./CarePlanWidget/CarePlanWidget";
import { PatientInfoWidget } from "./PatientInfoWidget";
import { WorkflowStepTransitionButtons } from "./WorkflowStepTransitionButtons";

export const DisplayWorkflowStepWithVideoClient = (componentProps) => {
  const { endCall, jumpWorkflowStep, props, state, step } = componentProps;
  const { currentStep, patientDetails, patientDiagnosis, progressNote } = state;
  let [fullScreenMode, setFullScreenMode] = React.useState(
    state.fullScreen || step.fullScreen || window.innerWidth < 1200,
  );

  React.useEffect(() => {
    function handleResize() {
      setFullScreenMode(state.fullScreen || step.fullScreen || window.innerWidth < 1200);
    }

    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let videoGroup = (
    <>
      <RemoteVideo
        {...props}
        endCall={endCall}
        fullscreenMode={fullScreenMode}
        note={progressNote}
      />
      <LocalVideo {...props} />
    </>
  );

  const shouldAdjustGuidedSessionHeight =
    currentStep && state?.workflow?.steps?.[currentStep]?.isDisplayingGuidedSession;

  if (fullScreenMode) return <div className="GuidedVideoCall__whole_screen_view">{videoGroup}</div>;

  return (
    <div
      className={createClassNameString([
        "GuidedVideoCall__guided_step row",
        shouldAdjustGuidedSessionHeight ? "GuidedVideoCall__adjusted_height" : null,
      ])}
    >
      <div className="GuidedVideoCall__video_details col-12 col-md-12 col-lg-7">
        <div className="d-none d-md-none d-lg-block">
          <PatientInfoWidget
            isLarger={false}
            patientDetails={patientDetails}
            patientDiagnosis={patientDiagnosis}
          />
        </div>

        <div className="GuidedVideoCall__guided_step_view">{videoGroup}</div>

        <CarePlanWidget
          carePlanTips={step.carePlanTips}
          noteContent={progressNote?.content}
          patientDetails={patientDetails}
        />
      </div>

      <div className="GuidedVideoCall__guided_widget px-0 d-none d-md-none d-lg-block col-lg-5">
        <CardSecondary className="h-100 Background">
          <div className="GuidedVideoCall__guided_widget_header_container">
            <div className="GuidedVideoCall__guided_widget_header_title">{step["caption"]}</div>
            <div className="GuidedVideoCall__guided_widget_header_subtitle">{step?.subTitle}</div>
          </div>

          <div className="GuidedVideoCall__guided_widget_content">
            {step.subComponent && state.refresh && <step.subComponent {...componentProps} />}
          </div>

          {!step.customTransition && (
            <WorkflowStepTransitionButtons
              currentStep={currentStep}
              onNextStep={() => jumpWorkflowStep(currentStep + 1)}
              onPreviousStep={() => jumpWorkflowStep(currentStep - 1)}
              workflow={state.workflow}
            />
          )}
        </CardSecondary>
      </div>
    </div>
  );
};
